export enum ContentType {
  TERMS_AND_CONDITION = 'TERMS_AND_CONDITION',
  PRIVACY_POLICY = 'PRIVACY_POLICY',
  FAQ = 'FAQ',
  // Add other types if needed
}
